export type Role = 'reader' | 'user' | 'support';

export const userOrSupportRestriction = ['user', 'support'] as Role[];
